import { ValueObject } from '../shared/ValueObject';
import type { RegisterDisplayItem } from '@/features/panels/constants/panelDetailTab.constants';

// ========== 型定義 ==========

interface SensorDisplayValueProps {
  readonly displayName: string;
  readonly rawValue: number | null;
  readonly unit: string;
  readonly precision: number;
  readonly divisor: number;
}

// ========== 値オブジェクト ==========

/**
 * 見える化センサー計測値の値オブジェクト
 *
 * センサーの表示名・計測値・単位・精度を不変に保持する。
 * 生成時に完全な状態であり、変更は新インスタンス生成で対応。
 */
export class SensorDisplayValue extends ValueObject<SensorDisplayValueProps> {
  private constructor(props: SensorDisplayValueProps) {
    super(props);
  }

  /**
   * SensorDisplayValueを生成
   */
  public static create(props: SensorDisplayValueProps): SensorDisplayValue {
    return new SensorDisplayValue({
      displayName: props.displayName,
      rawValue: props.rawValue,
      unit: props.unit,
      precision: props.precision,
      divisor: props.divisor,
    });
  }

  public getDisplayName(): string {
    return this.value.displayName;
  }

  public getRawValue(): number | null {
    return this.value.rawValue;
  }

  public getUnit(): string {
    return this.value.unit;
  }

  public getPrecision(): number {
    return this.value.precision;
  }

  /**
   * プレゼンテーションモデルに変換
   */
  public toPresentationModel(): RegisterDisplayItem {
    return {
      name: this.value.displayName,
      value: this.value.rawValue !== null
        ? this.value.rawValue / this.value.divisor
        : null,
      unit: this.value.unit,
      precision: this.value.precision,
    };
  }
}
